import { millisecondsToTime } from "@/utils/iso8601ToDate";

// Утилиты для работы со временем
export const formatTimeToNext = (diff: number, prefix: string): string => {
  if (diff <= 0) return "Доступно";
  
  const { days, hours, minutes } = millisecondsToTime(diff);
  const pad = (n: number) => n.toString().padStart(2, "0");
  
  if (days === 0 && hours === 0 && minutes === 0) {
    return `${prefix} менее минуты`;
  }
  
  if (days === 0) {
    return `${prefix} ${hours} ч. ${pad(minutes)} мин`;
  }
  
  return `${prefix} ${days} д. ${hours} ч. ${minutes} мин`;
}; 